import React, {useState} from 'react';

import {CreateEntityButton} from 'entities/tariff';

import {IAdminEntityModalProps} from './AdminFormModal';

interface IAdminCreateButtonProps<T> {
    label: string,
    Modal: React.ComponentType<IAdminEntityModalProps<T>>,
}

const AdminCreateButton = <T, >({label, Modal}: IAdminCreateButtonProps<T>) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <CreateEntityButton ariaLabel={label} onClick={() => setIsModalOpen(true)}>
                {label}
            </CreateEntityButton>
            <Modal open={isModalOpen} handleClose={() => setIsModalOpen(false)}/>
        </>
    );
};

export default AdminCreateButton;
